import type { FloatingPortalProps } from '@floating-ui/react';
import { FloatingPortal as BaseFloatingPortal } from '@floating-ui/react';

import { useRootContainer } from '#/context/RootContainerContext';

export function FloatingPortal(props: FloatingPortalProps) {
  const rootContainer = useRootContainer();

  return (
    <BaseFloatingPortal root={rootContainer ?? document.body} {...props} />
  );
}
